module.exports = __webpack_public_path__ + "static/andreea-2b2850bba17436c9f082ea41f940721f.jpg";